module.exports = __webpack_public_path__ + "img/user-circle.a17ce457.svg";